<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-spectrum/view';
import {HeaderInfo, PropTable} from '@react-spectrum/docs';
import packageData from '@react-spectrum/view/package.json';

```jsx import
import {Footer} from '@react-spectrum/view';
```

---
category: Content
---

# Footer

<p>{docs.exports.Footer.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['Footer']} />

## Examples

```tsx example
<Footer>&copy; All rights reserved.</Footer>
```

## Content

The Footer component is used as a child to other components. Based on the
component it is used within, it gets Spectrum styling and may have a preassigned
slot for positioning. By virtue of its name, the Footer component provides
semantic meaning in the context they are placed. An example of this is
explained in [Dialog](Dialog.html#content). It is important to note
that the Footer element accepts any renderable node, not just strings.

A Footer is used to specify a layout region below the content section of a component.
Example usage can be found in [Dialog](Dialog.html#example).

See [the MDN docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/footer) for more information.

## Props

<PropTable component={docs.exports.Footer} links={docs.links} />
